import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

import { matchUiAction } from "../detect";
import { Matcher } from "../types";
import { applyAndSettle } from "./settle";

export const setDevice: Matcher = {
  // A device switch can change which device-scoped mods apply, re-running the
  // preview state through the plugin; `applyAndSettle` waits for that to settle
  // when it happens, and returns immediately when it doesn't.
  match: (part) => {
    const results = matchUiAction(part, "setDevice");
    if (!results) return null;
    return async (api) => {
      await applyAndSettle(api, () =>
        api.dispatch(
          experienceBuilderSlice.actions.setDevice(
            results.device as "mobile" | "desktop"
          )
        )
      );
      return {
        kind: "user",
        message: `[system] Device switched to ${results.device}. Fresh page HTML is provided in variables.`,
      };
    };
  },
};
